import request from "../utils/request";

export async function createNewLoss(payload) {
  return request.post("Loss/Create", payload);
}

export async function createStockLoss(payload) {
  return request.post("Loss/CreateStock", payload);
}

export async function getLossStockNameList() {
  return request.get("Loss/LossStockNameList");
}

export async function getLossList(payload) {
 
  return request.get("Loss/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.lossDescription,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      lossReasonId: payload.lossReason != null ? payload.lossReason.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      rawMaterialId: payload.rawMaterial != null ? payload.rawMaterial.id : null,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  });
}

export async function getLossListForDealer(payload) {
 
  return request.get("Loss/ListForDealer", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.lossDescription,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      lossReasonId: payload.lossReason != null ? payload.lossReason.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      rawMaterialId: payload.rawMaterial != null ? payload.rawMaterial.id : null,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  });
}

export async function getLossExcel(payload) {
 
  return request.get("Loss/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.lossDescription,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      lossReasonId: payload.lossReason != null ? payload.lossReason.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      rawMaterialId: payload.rawMaterial != null ? payload.rawMaterial.id : null,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  });
}
